// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pixel-manager-mf .trigger-type-item{height:auto;cursor:pointer}.pixel-manager-mf .trigger-type-item:hover{border-color:var(--v-brand-blue-base,#00003c)}.pixel-manager-mf .trigger-type-item .type-info{width:85%;display:inline-block}.pixel-manager-mf .trigger-type-item .type-info .description{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
